import { $authHost } from "../../http";
import { 
    SERVICE_PRICE_LIST_GET_REQUEST, SERVICE_PRICE_LIST_GET_SUCCESS, SERVICE_PRICE_LIST_GET_ERROR, 
    SERVICE_PRICE_LIST_GET_BY_KEY_REQUEST, SERVICE_PRICE_LIST_GET_BY_KEY_SUCCESS, SERVICE_PRICE_LIST_GET_BY_KEY_ERROR, 
    SERVICE_PRICE_LIST_ADD_REQUEST, SERVICE_PRICE_LIST_ADD_SUCCESS, SERVICE_PRICE_LIST_ADD_ERROR, 
    SERVICE_PRICE_LIST_EDIT_REQUEST, SERVICE_PRICE_LIST_EDIT_SUCCESS, SERVICE_PRICE_LIST_EDIT_ERROR, 
    SERVICE_PRICE_LIST_DELETE_REQUEST, SERVICE_PRICE_LIST_DELETE_SUCCESS, SERVICE_PRICE_LIST_DELETE_ERROR
} from "../constants/servicePriceListConstants";

export const getServicePriceLists = (args) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_PRICE_LIST_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/servicePriceList/query",
            args || {},
            config,
        );
        dispatch({
            type: SERVICE_PRICE_LIST_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: SERVICE_PRICE_LIST_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getServicePriceListByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_PRICE_LIST_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/servicePriceList/${id}`,
        );
        dispatch({
            type: SERVICE_PRICE_LIST_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: SERVICE_PRICE_LIST_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addServicePriceList = ({ name, price, serviceId, unitId, currencyId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_PRICE_LIST_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/servicePriceList",
            { name, price, serviceId, unitId, currencyId },
            config,
        );
        dispatch(getServicePriceLists(queryArgs || {}));
        dispatch({
            type: SERVICE_PRICE_LIST_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_PRICE_LIST_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editServicePriceList = ({ id, name, price, serviceId, unitId, currencyId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_PRICE_LIST_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/servicePriceList",
            { id, name, price, serviceId, unitId, currencyId },
            config,
        );
        dispatch(getServicePriceLists(queryArgs || {}));
        dispatch({
            type: SERVICE_PRICE_LIST_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_PRICE_LIST_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteServicePriceList = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: SERVICE_PRICE_LIST_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/servicePriceList",
            { data: { id } },
            config,
        );
        dispatch(getServicePriceLists(queryArgs || {}));
        dispatch({
            type: SERVICE_PRICE_LIST_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: SERVICE_PRICE_LIST_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

